import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { GetCommentaryModuleName } from '@/store/modules/modules'

export class GetCommentaryViewModel {
  private store = useStore()

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${GetCommentaryModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${GetCommentaryModuleName}/error`])

  async getCommentary(
    displayLanguage: string,
    problemId: string,
    pattern: string,
    type: string,
    filter: string
  ): Promise<string> {
    return await this.store.dispatch(`${GetCommentaryModuleName}/getCommentary`, {
      displayLanguage,
      problemId,
      pattern,
      type,
      filter
    })
  }
}
